import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "verify-email-wrap" }
const _hoisted_2 = { class: "verify-email-notice" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "final-wrap mt-9" }
const _hoisted_5 = { class: "finalMessage" }
const _hoisted_6 = { href: "#" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { class: "finalMessage" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "finalMessage" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/auth/signup-final-icon.png",
  alt: ""
}, null, -1)

import { ref, inject } from "vue";
import i18n from "@/core/plugins/i18n";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import GlobalService from "@/projects/client/services/ClientGlobalService";


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailVerifyPage',
  setup(__props) {

const { t } = i18n.global;
const formData = inject<any>("formData");

const resendConfirmation = async () => {
  var confirmUrl =
    window.location.protocol + "//" + window.location.host + "/confirm-email";
  if (window.location.href.includes("portal")) {
    confirmUrl =
      window.location.protocol +
      "//" +
      window.location.host +
      "/portal/confirm-email";
  }
  try {
    await GlobalService.resendConfirmationEmail(
      formData.value.email,
      confirmUrl
    );

    MsgPrompt.success(t("tip.confirmationEmailResend"));
  } catch (error) {
    MsgPrompt.error(error);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("tip.verifyYourEmail")), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.$t("tip.thankSignUpAndConfirm")) + " ", 1),
            _createElementVNode("a", _hoisted_6, _toDisplayString(_unref(formData).email), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("tip.toActivateYourAccount")), 1)
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("tip.linkExpireContact")), 1),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createTextVNode(_toDisplayString(_ctx.$t("tip.notReceiveEmail")), 1),
            _hoisted_11,
            _createElementVNode("a", {
              href: "#",
              onClick: resendConfirmation
            }, _toDisplayString(_ctx.$t("action.resendEmail")), 1)
          ])
        ]),
        _hoisted_12
      ])
    ])
  ]))
}
}

})